import {
  configureStyleProcessing,
  cssClass,
} from "@vue-styled-components/core";

export { keyframes, cssClass, css } from "@vue-styled-components/core";

export const clsx = (...classes: (string | undefined | unknown)[]) =>
  classes.filter((className) => className).join(" ");

configureStyleProcessing({
  enableCache: false,
  cacheSize: 0,
  enableBatchUpdates: true,
  batchDelay: 8,
  enableAsync: true,
  enablePerformanceMonitoring: false,
});

export const estyled = {
  cssClass,
};
